module.exports = __webpack_public_path__ + "static/media/right.1e9a60e1.svg";